'use client';

import ArrowDown106 from '@svg/trip/arrow_down_10_6.svg';
import { TravelCardCGType } from '@/types/graphql/root';
import { useCallback, useMemo, useRef, useState } from 'react';
import TravelCard from './travel-card';

export default function TravelCardsClient({ travelCards }: { travelCards: TravelCardCGType[] }) {
  const firstTravelCardRef = useRef<HTMLAnchorElement>(null);

  const INITIAL_VISIBLE_COUNT = 4;
  const LOAD_MORE_COUNT = 4;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);

  const visibleCards = useMemo(() => {
    if (visibleCount >= travelCards.length) {
      return travelCards;
    }
    return travelCards.slice(0, visibleCount);
  }, [travelCards, visibleCount]);

  const handleMore = useCallback(() => {
    setVisibleCount((_prev) => _prev + LOAD_MORE_COUNT);
    if (firstTravelCardRef.current) {
      const cardHeight = firstTravelCardRef.current.clientHeight;
      const gap = 12;
      if (cardHeight) {
        window.scrollTo({
          top: window.scrollY + (cardHeight + gap) * 2,
          behavior: 'smooth',
        });
      }
    }
  }, []);

  const handleFold = useCallback(() => {
    setVisibleCount(INITIAL_VISIBLE_COUNT);
    if (firstTravelCardRef.current) {
      const cardHeight = firstTravelCardRef.current.clientHeight;
      const gap = 12;
      if (cardHeight) {
        window.scrollTo({
          top: window.scrollY - (cardHeight + gap) * 4,
          behavior: 'smooth',
        });
      }
    }
  }, []);

  return (
    <>
      <div className='w-full grid grid-cols-2 gap-12pxr'>
        {visibleCards.map((travelCard, index) => (
          <TravelCard
            key={travelCard.id}
            ref={index === 0 ? firstTravelCardRef : null}
            id={travelCard.id}
            imageUrl={travelCard.mainImageUrl}
            name={`${travelCard.country} ${travelCard.name}`}
            engName={travelCard.nameEng.toUpperCase()}
          />
        ))}
      </div>
      {visibleCount < 12 && visibleCount < travelCards.length && (
        <button
          className='w-full h-32pxr border border-new-gray-300 bg-white rounded-6pxr flex items-center justify-center gap-2pxr mt-20pxr'
          onClick={handleMore}
        >
          <span className='body-12-md text-new-gray-900'>더보기</span>
          <ArrowDown106 />
        </button>
      )}
      {visibleCount >= 12 && (
        <button
          className='w-full h-32pxr border border-new-gray-300 bg-white rounded-6pxr flex items-center justify-center gap-2pxr mt-20pxr'
          onClick={handleFold}
        >
          <span className='body-12-md text-new-gray-900'>접기</span>
          <ArrowDown106 className='rotate-180' />
        </button>
      )}
    </>
  );
}
